import { MouseEventHandler } from 'react'

import cx from 'classnames'
import Link from 'next/link'

import { Loader } from '@/components/Loader'

import { COLOR_BLACK, COLOR_WHITE } from '../../utils/styles'

import styles from './Button.module.scss'

export type ButtonProps<T extends MouseEventHandler<HTMLButtonElement> = MouseEventHandler<HTMLButtonElement>> = {
  additionalClasses?: string | string[]
  content?: string | JSX.Element
  disabled?: boolean
  loading?: boolean
  'data-cy'?: string
  'data-type'?: string
  type?: 'Primary' | 'Secondary' | 'Tertiary' | 'OutlinePrimary' | 'OutlineSecondary'
  onClick?: T
  href?: string
}

function strokeColor(type: ButtonProps['type']) {
  switch (type) {
    case 'Secondary':
    case 'OutlineSecondary':
      return COLOR_BLACK
    default:
      return COLOR_WHITE
  }
}

export const Button: React.FC<ButtonProps> = ({
  children,
  additionalClasses,
  type = 'Primary',
  content,
  disabled,
  loading,
  'data-cy': dataCy,
  onClick,
  href,
  'data-type': dataType,
}) => {
  const buttonComponent = (
    <button
      disabled={disabled}
      className={cx(styles.Button, styles[type], additionalClasses)}
      onClick={onClick}
      data-cy={dataCy}
      data-type={dataType}
    >
      {loading ? <Loader dataCy={`${dataCy}-loader`} strokeColor={strokeColor(type)} /> : children ? children : content}
    </button>
  )

  if (href) {
    return (
      <Link href={href}>
        <a className={styles.Link}>{buttonComponent}</a>
      </Link>
    )
  }

  return buttonComponent
}
